import { SET_PRICING_MODULE } from '../actions/types';

export default function pricingModuleData(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_PRICING_MODULE:
				return { ...state, ...action.payload };
			default:
		}
	}
	return state;
}
